import React from 'react';
import { Checkbox } from '@sumologic/yama-ds-components';

export const checkboxCellRender = props => {
    const bool = props.value;
    return (
        <Checkbox
            checked={bool}
            disabled={true}
            className="table-cell-checkbox"
        />
    );
    /*
     return <i className={`icon icon-${props.value ? 'check' : 'cross'}`} />;
    */
};
